module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Or just send us an email"},"nl":{"title":"Of stuur gewoon een mailtje"}}')
  delete Component.options._Ctor
}
